const BASE_URL = 'https://api.themoviedb.org/3/trending/movie/day';

export default BASE_URL;
